export default "__VITE_ASSET__WwYL23I9__"